// Firebase Cloud Messaging (FCM) setup for web push notifications.
// This app is Create React App (react-scripts), so env vars use process.env.REACT_APP_*.
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDsArKkD-ndh6wu-h6KpNpf5kXW9qdktHw",
  authDomain: "ifillip-f7feb.firebaseapp.com",
  projectId: "ifillip-f7feb",
  storageBucket: "ifillip-f7feb.firebasestorage.app",
  messagingSenderId: "50881695748",
  appId: "1:50881695748:web:c792ae43a918226b3aa551",
  measurementId: "G-HC7Q25B71C",
};

const app = initializeApp(firebaseConfig);

// Web Push certificate key pair.
// Firebase Console -> Project Settings -> Cloud Messaging -> Web Push certificates.
const VAPID_KEY =
  process.env.REACT_APP_FIREBASE_VAPID_KEY ||
  "BPqAW9a-YmZ3FY32Ob-9D6qBH83c6xTtfVf7lA5Nc_N92xPs0ZoRtPOlYV6NmOE2eKx4K1dL2qgG_nm6c-YtfP0";

// getMessaging throws in unsupported environments (e.g. no service worker /
// insecure context). Guard so the app still boots without notifications.
let messagingPromise = null;
const getMessagingSafe = async () => {
  if (messagingPromise) return messagingPromise;
  messagingPromise = (async () => {
    try {
      if (!(await isSupported())) return null;
      return getMessaging(app);
    } catch (e) {
      console.warn("FCM not supported in this browser:", e);
      return null;
    }
  })();
  return messagingPromise;
};

/**
 * Request browser notification permission, register the service worker, and
 * return an FCM registration token. Returns null if unsupported/denied.
 */
export async function requestFcmToken() {
  if (!("Notification" in window) || !("serviceWorker" in navigator)) {
    return null;
  }
  if (!VAPID_KEY) {
    console.error(
      "REACT_APP_FIREBASE_VAPID_KEY is not set — getToken() will fail. " +
        "Add it to your .env and restart the dev server.",
    );
    return null;
  }

  const messaging = await getMessagingSafe();
  if (!messaging) return null;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  const registration = await navigator.serviceWorker.register(
    "/firebase-messaging-sw.js",
  );

  return getToken(messaging, {
    vapidKey: VAPID_KEY,
    serviceWorkerRegistration: registration,
  });
}

/**
 * Subscribe to foreground (tab focused) messages.
 * Returns an unsubscribe function (or a no-op if unsupported).
 */
export function onForegroundMessage(callback) {
  let unsubscribe = () => {};
  getMessagingSafe().then((messaging) => {
    if (messaging) unsubscribe = onMessage(messaging, callback);
  });
  return () => unsubscribe();
}

/**
 * Delete the FCM token for this device so the next user on this machine does
 * not inherit the previous user's push subscription. Call on logout.
 */
export async function clearFcmToken() {
  const messaging = await getMessagingSafe();
  if (!messaging) return false;
  try {
    return await deleteToken(messaging);
  } catch (e) {
    console.warn("Failed to delete FCM token:", e);
    return false;
  }
}
